// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","secondary":"#33C370","wrapper":"_1GDiKvcdBJvz9GENvOz1Xt","horizontal":"_2VAaCoQIj9vuWZ8FdB9Pgk","checkbox":"_3IwEYHNm2P1rz4YlWircXj","answersByGroup":"_3K5lsi9pYeytL6mjFrT0vh"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/CheckBoxInput.mod.css
// module id = 1700
// module chunks = 0